export enum OperatingSystem {
  Hardware = 'Physisch / Hardware',
  VirtualBox = 'Virtuell / VirtualBox',
  HyperV = 'Virtuell / HyperV',
  VMware = 'Virtuell / VMWare',
}

export namespace OperatingSystem {
  export function mapFromApiValue(osName: string): OperatingSystem | string {
    if (!osName) {
      return OperatingSystem.Hardware;
    }
    const normalized = osName.toUpperCase();
    if (normalized.includes('VIRTUALBOX')) {
      return OperatingSystem.VirtualBox;
    }
    if (normalized.includes('HYPERV') || normalized.includes('HYPER-V')) {
      return OperatingSystem.HyperV;
    }
    if (normalized.includes('VMWARE')) {
      return OperatingSystem.VMware;
    }
    if (normalized.includes('HARDWARE') || normalized.includes('PHYSISCH') || normalized.includes('PHYSICAL')) {
      return OperatingSystem.Hardware;
    }
    return osName;
  }

  export const name = (os: OperatingSystem | string): string => {
    switch (os) {
      case OperatingSystem.Hardware:
        return OperatingSystem.Hardware;
      case OperatingSystem.VirtualBox:
        return OperatingSystem.VirtualBox;
      case OperatingSystem.HyperV:
        return OperatingSystem.HyperV;
      case OperatingSystem.VMware:
        return OperatingSystem.VMware;
      default:
        return typeof os === 'string' ? os : '';
    }
  };

  export const icon = (_os: OperatingSystem | string): string | undefined => {
    return undefined;
  };
}
